module.exports = __webpack_public_path__ + "static/media/mean_stack_development.66a34b14.svg";